import React from "react";
import "./InputFieldStyle.css";

const InputField = ({
  type,
  className,
  placeholder,
  id,
  labelName,
  checkBoxWrap,
  onChange,
  disabled,
  value,
  checked,
  isError,
  errorMessage,
  notImp,
  onKeyDown,
  blackLabel,
  name,
  inputIcon,
  onEyeClick,
  img
}) => {
  return (
    <div className={`formGroups ${checkBoxWrap ?? ""}`}>
      {labelName && <label className={blackLabel && "visible0"} htmlFor={id}>
        {labelName}
        {!notImp && <span className={"impRed"}> *</span>}
      </label>}
      {img && <img src={`/assets/icons/${img}.svg`} className='absoluteIcon' />}
      <input
        type={type}
        className={className}
        placeholder={placeholder}
        onKeyDown={onKeyDown}
        disabled={disabled}
        value={value}
        onChange={onChange}
        id={id}
        checked={checked}
        name={name}
      />
      {errorMessage && <span className="FormError w-100">{errorMessage}</span>}

      {inputIcon && <span className="inputIcon" onClick={onEyeClick}>
        <img src={`/assets/icons/${inputIcon}.svg`}/>
      </span>}

    </div>
  );
};

export default InputField;
